"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const addMonths_1 = __importDefault(require("date-fns/addMonths"));
const addYears_1 = __importDefault(require("date-fns/addYears"));
const endOfMonth_1 = __importDefault(require("date-fns/endOfMonth"));
const isAfter_1 = __importDefault(require("date-fns/isAfter"));
const isSameMonth_1 = __importDefault(require("date-fns/isSameMonth"));
const subYears_1 = __importDefault(require("date-fns/subYears"));
const react_1 = __importStar(require("react"));
const react_day_picker_1 = __importDefault(require("react-day-picker"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const libs_utils_1 = require("@hotelplan/libs.utils");
const TravelDates_utils_1 = require("./TravelDates.utils");
const DatePickerWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    mt: ['115px', 0],
}), ({ theme }) => theme.travelDates.travelDatesContainerCss);
function UnionDatePicker({ unionDatePickerRef, flexible, configuration, weekDaysShortForLanguage, monthsForLanguage, departureDate, returnDate, hoveredDate, maxDate, minDate, initialMonth, duration, onDayClick, onDayMouseEnter, selectedDays, applyInsideRange = true, icons, }) {
    const { hasNavbar, disablePrevMonth, disableNextMonth, canChangeMonth, changeYears, hasCustomWeekDayElement, numberOfMonthsToShow, } = configuration || {};
    const dayPickerRef = react_1.default.useRef(null);
    const isFirstDayOfDepartureDate = (0, react_1.useCallback)((day) => (0, isSameMonth_1.default)(day, departureDate) && day.getDate() === 1, [departureDate]);
    const navBarProps = (0, react_1.useMemo)(function () {
        const navBarMonthProps = {
            disableNextMonth,
            disablePrevMonth,
            icons,
        };
        if (changeYears === null || changeYears === void 0 ? void 0 : changeYears.enabled) {
            return Object.assign({ onChangeYear: (nextYear) => {
                    var _a;
                    (_a = dayPickerRef === null || dayPickerRef === void 0 ? void 0 : dayPickerRef.current) === null || _a === void 0 ? void 0 : _a.showMonth(nextYear);
                }, minYear: changeYears === null || changeYears === void 0 ? void 0 : changeYears.minYear, maxYear: changeYears === null || changeYears === void 0 ? void 0 : changeYears.maxYear }, navBarMonthProps);
        }
        return navBarMonthProps;
    }, [changeYears, disableNextMonth, disablePrevMonth, icons]);
    return (react_1.default.createElement(DatePickerWrapper, { tabIndex: -1, ref: unionDatePickerRef, className: flexible ? 'body flexible' : 'body' },
        react_1.default.createElement(react_day_picker_1.default, { ref: dayPickerRef, navbarElement: hasNavbar ? react_1.default.createElement(Navbar, Object.assign({}, navBarProps)) : undefined, weekdaysShort: weekDaysShortForLanguage, 
            // If we want customWeekDayElement we render it inside the header of this component
            weekdayElement: hasCustomWeekDayElement ? () => null : undefined, canChangeMonth: canChangeMonth, firstDayOfWeek: 1, className: "date-picker", numberOfMonths: numberOfMonthsToShow, selectedDays: selectedDays || [
                departureDate,
                {
                    from: departureDate,
                    to: returnDate
                        ? returnDate
                        : hoveredDate && hoveredDate > departureDate
                            ? hoveredDate
                            : departureDate,
                },
            ], modifiers: applyInsideRange
                ? {
                    'inside-range': flexible
                        ? (0, TravelDates_utils_1.getDatesForFlexibleRange)(departureDate, duration, returnDate, maxDate)
                        : [],
                    start: departureDate,
                    end: returnDate || departureDate,
                    firstDayOfDepartureDate: isFirstDayOfDepartureDate,
                }
                : {}, onDayClick: onDayClick, onDayMouseEnter: onDayMouseEnter, disabledDays: {
                after: maxDate,
                before: minDate,
            }, months: monthsForLanguage, month: initialMonth })));
}
exports.default = UnionDatePicker;
const isNMonthLater = (day, months) => {
    const lastDayOfMonth = (0, endOfMonth_1.default)(today);
    return (0, isAfter_1.default)(day, (0, addMonths_1.default)(lastDayOfMonth, months));
};
const NavbarButtons = styled_components_1.default.div(({ theme }) => theme.travelDates.navbarControlCss);
const NavbarButton = styled_components_1.default.button.attrs({
    type: `button`,
})({
    position: 'absolute',
});
const LeftNavbarButton = (0, styled_components_1.default)(NavbarButton).attrs({
    'data-id': `goToPrevMonth`,
})(({ canChangeYear }) => ({
    left: canChangeYear ? '50px' : '10px',
}));
const LeftDoubleChevronButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    variant: 'iconBtn',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    left: '10px',
}));
const RightDoubleChevronButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    variant: 'iconBtn',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    right: '10px',
}));
const MonthIcon = (0, styled_components_1.default)(components_common_icon_1.Icon)(({ theme }) => theme.icons.lg);
const RightNavbarButton = (0, styled_components_1.default)(NavbarButton).attrs({
    'data-id': `goToNextMonth`,
})(({ canChangeYear }) => ({
    right: canChangeYear ? '50px' : '10px',
}));
const today = (0, libs_utils_1.getTodaysDate)();
const DEFAULT_ICONS = {
    minusYear: `double-chevron-long-left`,
    plusYear: `double-chevron-long-right`,
    minusMonth: `chevron-long-left`,
    plusMonth: `chevron-long-right`,
};
const Navbar = props => {
    const { onPreviousClick, onNextClick, className, nextMonth, previousMonth, onChangeYear: handleChangeYear, minYear, maxYear, disablePrevMonth, disableNextMonth, icons = {}, } = props;
    const { minusYear, plusYear, minusMonth, plusMonth } = Object.assign(Object.assign({}, DEFAULT_ICONS), icons);
    const [currentDate, setCurrentDate] = react_1.default.useState((0, addMonths_1.default)(previousMonth, 1));
    (0, react_1.useEffect)(() => {
        if (handleChangeYear) {
            handleChangeYear(currentDate);
        }
    }, [currentDate, handleChangeYear]);
    const { prevMonthDisabled, nextMonthDisabled } = (0, react_1.useMemo)(function () {
        return {
            prevMonthDisabled: previousMonth.getMonth() < today.getMonth() &&
                previousMonth.getFullYear() === today.getFullYear(),
            nextMonthDisabled: isNMonthLater(nextMonth, 13),
        };
    }, [previousMonth, nextMonth]);
    return (react_1.default.createElement(NavbarButtons, { className: className },
        handleChangeYear ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(LeftDoubleChevronButton, { onClick: () => setCurrentDate((0, subYears_1.default)(currentDate, 1)), disabled: minYear && currentDate.getFullYear() <= minYear, icon: { name: minusYear } }),
            react_1.default.createElement(RightDoubleChevronButton, { onClick: () => setCurrentDate((0, addYears_1.default)(currentDate, 1)), disabled: maxYear && currentDate.getFullYear() >= maxYear, icon: { name: plusYear } }))) : null,
        react_1.default.createElement(LeftNavbarButton, { canChangeYear: Boolean(handleChangeYear), disabled: disablePrevMonth !== null && disablePrevMonth !== void 0 ? disablePrevMonth : prevMonthDisabled, onClick: () => onPreviousClick() },
            react_1.default.createElement(MonthIcon, { name: minusMonth })),
        react_1.default.createElement(RightNavbarButton, { canChangeYear: Boolean(handleChangeYear), disabled: disableNextMonth !== null && disableNextMonth !== void 0 ? disableNextMonth : nextMonthDisabled, onClick: () => onNextClick() },
            react_1.default.createElement(MonthIcon, { name: plusMonth }))));
};
//# sourceMappingURL=UnionDatePicker.js.map